<template>
  <div class="t-lk-modal__content">
    <h2 v-if="props.title" class="t-lk-modal__title">{{ props.title }}</h2>
    <h2 v-else class="t-lk-modal__title">{{ $root.staticText.lk.requestTitle }}</h2>

    <CoreForm
      class="t-lk-modal__form"
      action="lk/requests/send"
      :form-config="form"
      :submit-label="props.button"
      @submit:success="onSuccessSubmit"
      @submit:error="onErrorSubmit"
    ></CoreForm>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CoreForm from '@shared/ui/public/forms/CoreForm.vue'
import { FORM_COLOR_IDX, LEGACY_FORM_VARIANTS } from '@shared/const/form/form.data'

export default {
  name: 'request',
  components: {
    CoreForm,
  },
  props: ['props'],
  data() {
    return {
      form: {
        type: LEGACY_FORM_VARIANTS.DEFAULT_BUILDER,
        color: FORM_COLOR_IDX.WHITE,
        fields: [
          {
            type: 'form_field',
            content: {
              id: 'title',
              title: this.$root.staticText.lk.requestTitle2,
              typeField: 1,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderCompany2,
              addClass: '_full-lk _right0',
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'typeId',
              title: this.$root.staticText.forms.typeRequest,
              typeField: 7,
              requiredField: 1,
              description: null,
              hintField: this.$root.staticText.forms.placeholderTypeRequest2,
              list: this.props.options,
              addClass: '_right',
            },
          },
          {
            type: 'form_field',
            content: {
              id: 'comment',
              title: this.$root.staticText.forms.comment2,
              typeField: 2,
              requiredField: 1,
              description: null,
              hintField: null,
              addClass: '_right0',
            },
          },
        ],
      },
    }
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),

    onSuccessSubmit() {
      this.modalClose()

      this.modalType_lkSuccessOpen({
        title: this.$root.staticText.modal.successTitleFeedback,
        text: this.$root.staticText.modal.successTextFeedback,
        closeBthNone: true,
      })
    },
    onErrorSubmit() {
      this.modalClose()

      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: this.$root.staticText.lk.lkErrorText,
        closeBthNone: true,
      })
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/request.vue